import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class GoalsListItemComponent extends Component {
  @service betaToggle;

  @tracked isExpanded = true;

  @action
  toggleCollapse() {
    this.isExpanded = !this.isExpanded;
  }

  get matchesFilter() {
    const callback = this.matchChecker;
    return callback(this.args.goal);
  }

  get children() {
    return this.args.goal.sortedChildren;
  }

  get matchChecker() {
    if (this.args.matchChecker) return this.args.matchChecker;
    return () => {
      return true;
    };
  }
}
